module.exports = __webpack_public_path__ + "img/ai-1.a3142488.jpg";